import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import clsx from 'clsx'
import { withStyles } from '~/themes/useStyles'
import Button from '../Button'
import Icon from '~/components/common/Icon'
import { COLORS } from '~/themes/common'

const style = () => ({
  root: {
    fontWeight: 400,
  },
  notActive: {
    background: COLORS.gray.disableGray2,
    color: COLORS.palette.black,
    border: '1px solid transparent !important',
  },
  disabled: {
    background: COLORS.gray.disableGray2,
    color: COLORS.gray.disableGray,
    border: `1px solid ${COLORS.gray.disableGray}`,
    pointerEvents: 'none',
  },
})

const SelectButton = ({
  classes,
  buttons,
  onChange,
  value,
  buttonClassName,
  disabled,
  startIconClassName,
  className,
}) => {
  const genColorIcon = (button) => {
    if (disabled) return COLORS.gray.disableGray
    if (value === button.value) return COLORS.palette.primaryBlue
    return COLORS.palette.black
  }

  return (
    <Grid container spacing={1} className={className}>
      {buttons.map((button, index) => (
        <Grid item xs={6} key={index}>
          <Button
            className={clsx(
              classes.root,
              value !== button.value && classes.notActive,
              disabled ? classes.disabled : '',
              buttonClassName,
            )}
            key={button.value}
            label={button.label}
            color="secondary"
            variant="outlined"
            startIcon={
              button.icon && (
                <Icon
                  name={button.icon}
                  size="small"
                  color={genColorIcon(button)}
                  className={startIconClassName}
                />
              )
            }
            onClick={() => !disabled && onChange(button.value)}
          />
        </Grid>
      ))}
    </Grid>
  )
}

SelectButton.defaultProps = {
  buttons: [],
  onChange: () => {},
  buttonClassName: '',
  disabled: false,
  startIconClassName: '',
  className: '',
}

SelectButton.propTypes = {
  classes: PropTypes.shape().isRequired,
  buttons: PropTypes.oneOfType([PropTypes.shape(), PropTypes.array]),
  onChange: PropTypes.func,
  buttonClassName: PropTypes.string,
  disabled: PropTypes.bool,
  startIconClassName: PropTypes.string,
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default withStyles(style)(SelectButton)
